import React, { useState, useEffect } from 'react';
import Loader from '@components/common/Loader/newLoaderModal';
import { APP_CONFIG, COUNTRY_CODE } from '@constants';
import StagePaymentComp from '@components/StagePayment/paymentTerminalStagePayment';
import { findIndex } from 'lodash';
import cn from 'classnames';
import {
  setSeat,
  updateWithPaymentStages,
  removeWithPaymentStages,
  setPaymentCheck,
} from '@reducers/orders';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNotification } from '@reducers/notification';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import { getObjectValue } from '@utility/utills';
import { flowType } from '@utility/userInfo';
import { openEmployeeCheck } from '@reducers/oauth';
import EmployeeCheck from '@components/checksCommon/employeeCheck';
import SwipeComponent from './SwipeComponent';

const PaymentTerminalStagePayment = props => {
  const { seat, deviceInfo } = props;
  const countryCode = getObjectValue(
    () => COUNTRY_CODE[props.auth.country].dialCode,
    '1'
  );
  const isDefaultMode = getObjectValue(
    () =>
      !deviceInfo.deviceGroup || [0].includes(deviceInfo.deviceGroup.startMode),
    false
  );
  const lockPaymentScreen = getObjectValue(
    () => props.auth.serverAppFeatures.lockPaymentScreen && isDefaultMode,
    false
  );
  const [selectedStage, setSelectedStage] = useState();
  const [selectedStageIndex, setSelectedStageIndex] = useState();

  const sortStages = data => {
    return data.sort((a, b) => a.status - b.status);
  };

  const getTotalAmount = amount => {
    return Number(amount) > 0 ? amount : 0;
  };

  const getSubTotalAmount = table => {
    return props.auth.country === 4
      ? +(table.subTotalAmount - table.taxAmount)
      : +table.subTotalAmount;
  };

  const seatItemHashTable = {};
  let tempTaxCal = 0;
  seat.paymentStages.forEach((paymentStageData, i) => {
    const itemsArray = [];
    let subTotalAmount = 0;
    let serviceChargeAmount = 0;
    let discountAmount = 0;
    seat.items.forEach(it => {
      let price = 0;
      let flag = false;
      let count = 0;
      paymentStageData.seats.forEach(nSeat => {
        const index = findIndex(it.seats, d => d.seatId === nSeat.seatId);
        if (index !== -1) {
          flag = true;
          count += 1;
          price += it.seats[index].splitAmount;
        }
      });
      if (flag) {
        subTotalAmount += price;
        itemsArray.push({
          ...it,
          oldPrice: it.price,
          price,
          splitValueString:
            count === it.seats.length ? '' : `${count}/${it.seats.length} `,
        });
      }
    });
    seat.serviceCharges.forEach(serviceCharge => {
      let serviceChargeValue = 0;
      let flag = false;
      paymentStageData.seats.forEach(nSeat => {
        const index = findIndex(
          serviceCharge.seats,
          d => d.seatId === nSeat.seatId
        );
        if (index !== -1) {
          flag = true;
          serviceChargeValue += serviceCharge.seats[index].splitAmount;
        }
      });
      if (flag) {
        serviceChargeAmount += serviceChargeValue;
      }
    });
    seat.discounts.forEach(discount => {
      let discountValue = 0;
      let flag = false;
      paymentStageData.seats.forEach(nSeat => {
        const index = findIndex(discount.seats, d => d.seatId === nSeat.seatId);
        if (index !== -1) {
          flag = true;
          discountValue += discount.seats[index].splitAmount;
        }
      });
      if (flag) {
        discountAmount += discountValue;
      }
    });
    const taxAmt = +((subTotalAmount * seat.taxAmount) / seat.subTotalAmount);
    const taxAmount =
      i === seat.paymentStages.length - 1
        ? +(seat.taxAmount - Number(tempTaxCal).toFixed(2))
        : +taxAmt.toFixed(2);
    tempTaxCal += +taxAmt.toFixed(2);
    seatItemHashTable[paymentStageData.id] = {
      paymentStageId: paymentStageData.id,
      items: itemsArray,
      taxAmount,
      subTotalAmount,
      stage: paymentStageData,
      status: paymentStageData.status,
      totalAmount:
        countryCode === '44'
          ? getTotalAmount(
              +(subTotalAmount + serviceChargeAmount - discountAmount)
            )
          : getTotalAmount(
              +(
                taxAmount +
                subTotalAmount +
                serviceChargeAmount -
                discountAmount
              )
            ),
      unpaidAmount: +(
        taxAmount +
        subTotalAmount +
        serviceChargeAmount -
        discountAmount
      ).toFixed(2),
      seats: seat.seats.reduce((a, v) => {
        if (paymentStageData.seats.some(d => d.seatId === v.id)) {
          a.push({ ...v });
        }
        return a;
      }, []),
      paidAmount: 0,
      serviceChargeAmount: +serviceChargeAmount.toFixed(2),
      discountAmount: +discountAmount.toFixed(2),
    };
  });
  const onClickPaymentHandler = paymentInfo => {
    if (Object.values(seatItemHashTable).find(e => e.unpaidAmount < 0)) {
      props.setNotification({
        type: 'danger',
        message: CUSTOM_MESSAGES().NEGATIVE_BALANCE,
      });
    } else {
      props.setSeat({
        ...seat,
        stageData: paymentInfo,
        totalAmount: paymentInfo.totalAmount,
      });
      props
        .setPaymentCheck({
          ...seat,
          stageData: paymentInfo,
          ...paymentInfo,
          subTotalAmount: getSubTotalAmount(paymentInfo),
        })
        .then(() => {
          props.history.replace({
            pathname: `${APP_CONFIG.BASE_URL}/receipt/${seat.id}?ticketSplitTypeId=1&splitValue=1&screenType=2&type=stage`,
          });
        });
    }
  };

  const handleRouteToCheckListing = () => {
    if (!lockPaymentScreen) {
      props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
    } else {
      props.openEmployeeCheck();
    }
  };

  const sortedSeatItemHashTable =
    Object.values(seatItemHashTable).length > 0 &&
    sortStages(Object.values(seatItemHashTable));

  useEffect(() => {
    if (sortedSeatItemHashTable) {
      setSelectedStage(sortedSeatItemHashTable[0]);
      setSelectedStageIndex(0);
    }
  }, []);

  const onSwipedLeft = () => {
    if (selectedStageIndex < sortedSeatItemHashTable.length - 1) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex + 1]);
      setSelectedStageIndex(selectedStageIndex + 1);
    } else if (selectedStageIndex === sortedSeatItemHashTable.length - 1) {
      setSelectedStage(sortedSeatItemHashTable[0]);
      setSelectedStageIndex(0);
    }
  };

  const onSwipedRight = () => {
    if (selectedStageIndex === 0) {
      setSelectedStage(
        sortedSeatItemHashTable[sortedSeatItemHashTable.length - 1]
      );
      setSelectedStageIndex(sortedSeatItemHashTable.length - 1);
    } else if (selectedStageIndex <= sortedSeatItemHashTable.length - 1) {
      setSelectedStage(sortedSeatItemHashTable[selectedStageIndex - 1]);
      setSelectedStageIndex(selectedStageIndex - 1);
    }
  };

  const handleLock = () => {
    props.history.replace(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`);
  };

  return (
    <div className="d-flex p-2 h-100">
      {props.loading && <Loader />}
      {!lockPaymentScreen && (
        <div
          className="position-absolute text-primary od-text-primary fs-26"
          style={{ left: '5px', top: '4px', zIndex: '999' }}
        >
          <i
            role="presentation"
            className="fa fa-chevron-left"
            aria-hidden="true"
            onClick={() =>
              props.history.replace(
                `${APP_CONFIG.BASE_URL}/stage/${props.seat.id}`
              )
            }
          />
        </div>
      )}
      <div
        className="position-absolute text-primary od-text-primary"
        style={{ right: '5px', top: 0, zIndex: '999' }}
        role="presentation"
        onClick={() => handleRouteToCheckListing()}
      >
        {!lockPaymentScreen ? (
          <i
            role="presentation"
            className="fa fa-times fs-26"
            aria-hidden="true"
          />
        ) : (
          <i
            role="presentation"
            className="fa fa-lock fs-26"
            aria-hidden="true"
          />
        )}
      </div>
      <div className="col-12 mb-2 mt-4 p-0 h-95">
        {selectedStage && (
          <SwipeComponent
            title="Carousel"
            onSwipedLeft={onSwipedLeft}
            onSwipedRight={onSwipedRight}
          >
            <div className="col-12 col-md-4 d-flex align-items-center justify-content-center text-primary od-text-primary h-5 fs-20">
              {CUSTOM_MESSAGES().SELECT_CHECK}
            </div>
            <div
              key={selectedStage.paymentStageId}
              className={cn('col-12 col-md-4 p-0 h-90')}
              // style={{ borderRadius: '50px' }}
            >
              <StagePaymentComp
                stageData={selectedStage.stage}
                tableData={seat}
                stageInfo={selectedStage}
                seatItems={selectedStage.items}
                currencySymbol={LABEL().CURRENCY_SYMBOL}
                countryCode={countryCode}
                onClickPaymentHandler={onClickPaymentHandler}
                auth={props.auth}
                node={0}
              />
            </div>
            <div className="col-12 px-1 row justify-content-center mx-0 pt-10 h-5 align-items-center">
              {sortedSeatItemHashTable.map((stage, index) => {
                return (
                  <div
                    key={stage.paymentStageId}
                    className={cn(
                      'px-1',
                      selectedStageIndex === index
                        ? 'od-text-primary text-primary'
                        : 'od-text-secondary text-secondary'
                    )}
                    role="presentation"
                    onClick={() => {
                      setSelectedStage(sortedSeatItemHashTable[index]);
                      setSelectedStageIndex(index);
                    }}
                  >
                    <i className="fas fa-circle fs-22" aria-hidden="true" />
                  </div>
                );
              })}
            </div>
          </SwipeComponent>
        )}
      </div>
      {props.isEmployeeCheck && (
        <EmployeeCheck
          {...props}
          callBack={() => {
            handleLock();
          }}
          caseType={flowType()}
        />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  deviceInfo: state.oauth.deviceInformation,
  userInfo: state.oauth.loggedInUserData,
  auth: state.oauth.authInfo,
  seat: state.orders.seats,
  position: state.orders.position,
  loading: state.stage.loading || state.orders.loading,
  isEmployeeCheck: state.oauth.isEmployeeCheck,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setNotification,
      updateWithPaymentStages,
      removeWithPaymentStages,
      setPaymentCheck,
      openEmployeeCheck,
      setSeat,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PaymentTerminalStagePayment);
